import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DataProvider } from '../../providers/data/data';

import {BarcodeScannerOptions} from '@ionic-native/barcode-scanner';
import { Cow_Weight } from '../cow_weight/cow_weight';


@Component({
  selector: 'page-cow-notification',
  templateUrl: 'cow_notification.html'
})
export class Cow_Notification {
  options: BarcodeScannerOptions

  scannedData:any={};

  public CowType;
  public COWS = []
  public farms = [];
  public unincluded = [];
  
  
  public farm: any;
  public Cow_Code: string;
  public Cow_Name: string;
  public Birth_Date: Date;
  public Sex: any;
  public Cow_Type: any;
  public Cow_Status: any;
  public Cow_Weight: any;
  public Cow_Temperature: any;
  public Cow_Height: any;
  public loader;
  public id;

  constructor(public navCtrl: NavController,
    private data: DataProvider,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    navParams: NavParams,) {
      this.id = navParams.get('id');
  }
  ionViewDidLoad() {
    this.farms = JSON.parse(localStorage.getItem('farms'));
    if(this.id == "1"){
      this.unincluded = JSON.parse(localStorage.getItem('notifications_weight_unincluded'));
      this.unincluded
    } else {
      this.unincluded = JSON.parse(localStorage.getItem('notifications_weight_included'));
    }
    
    
  }
  cowWeight(){
    this.navCtrl.setRoot(Cow_Weight);
  }
  
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Мэдээллүүд';
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 3000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({ 
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(()=>{
      this.loader = null;
    })
  }
  hideLoader() {
    if(this.loader)
      this.loader.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cow_notification/cow_notification.ts